module.exports = __webpack_public_path__ + "img/mp3-player.4aa9de31.svg";